export const metaData = {
  'meta-title': 'Lending - financial data solutions',
  'meta-description':
    'Plaid provides borrowers with an easy, streamlined loan experience, and lenders with access to bank data to make informed loan decisions.',
};

export const pageHeaderData = {
  'content-width-classes': 'page-header-breakpoint-6 large-6',
  label: true,
  'label-text': 'Lending',
  header:
    'A faster, more secure way to assess a borrower’s bank transactions, income and expenses',
  'header-class': 'h2',
  subheader: null,
  'primary-cta': true,
  'primary-cta-text': 'Contact sales',
  'primary-cta-link': '#contactForm',
  'secondary-cta': false,
  'secondary-cta-text': null,
  'tertiary-cta':
    'Or, <a class="signup-attach-utm" href="//dashboard.plaid.com/signup">get started</a>',
  image: true,
  'image-width': 1140,
  'image-height': 530,
  'image-url':
    'https://images.ctfassets.net/ss5kfr270og3/7d07SbwMgZbOwtiqpA5KkZ/e705950e43a29b352947210e3da7c4f4/lending-hero-intl.png?fm=webp&q=70',
  'image-classes': 'page-header-bg__img-overflow-large',
};

export const socialProofData = {
  header: 'Customers using this solution',
  alignment: 'center',
  'column-count': 4,
  'full-width': true,
  logos: [
    {
      img: '/assets/img/logos/logo-funding-circle-black600.png',
      alt: 'Funding Circle',
    },
    {
      img: '/assets/img/logos/logo-credit-karma-black600.png',
      alt: 'Credit Karma',
    },
    {
      img: '/assets/img/logos/logo-sofi-black600.png',
      alt: 'SoFi',
    },
    {
      img: '/assets/img/logos/logo-upstart-black600.png',
      alt: 'Upstart',
    },
  ],
};

export const introSectionData = {
  'problem-statement':
    'Lenders must gather holistic pictures of their applicants, but the process of assessing cash flow, affordability, and income creates considerable work for both the borrower and lender.',
  'solution-statement':
    'Plaid provides borrowers with an easy, streamlined loan experience; and lenders with access to bank data to make informed loan decisions.',
};

export const featureSectionData = {
  'feature-section-title': [
    {
      label: 'Products and benefits',
    },
  ],
  'feature-section-items': [
    {
      img: '/assets/img/products/intl-transactions-112@2x.png',
      title: 'Verify borrowers’ cash flow',
      'header-class': 'h5',
      content:
        '<a href="/eu/products/transactions">Transactions</a> provides 5+ years of clean, categorised data for personal accounts leveraging Open Banking data to assess cash flow',
      'no-link': true,
    },
    {
      img: '/assets/img/products/intl-assets-112@2x.png',
      title: 'Verify borrowers’ assets digitally',
      'header-class': 'h5',
      content:
        '<a href="/eu/products/assets">Assets</a> provides a consolidated report with account balances, uncategorised and categorised transactions, and account identity information',
      'no-link': true,
    },
  ],
};

export const simpleCarouselData = {
  'carousel-title': 'How It Works',
  'carousel-slides': [
    {
      header: 'Integrate with Plaid',
      description:
        'It takes just a few lines of code to drop our front-end module into your app or digital service. Your users will be prompted to connect their bank account, which will launch the Plaid module.',
      'bg-color': 'bg-green',
      img: '/assets/img/carousel/use-cases-carousel-0.png',
    },
    {
      header: 'Customise for conversion',
      description:
        'Customise the module to fit your brand or user preferences, including which financial institutions show up first.',
      'bg-color': 'bg-blue',
      img: '/assets/img/carousel/use-cases-carousel-link-demo-1.png',
    },
    {
      header: 'Get user-permissioned bank data',
      description:
        'Once a user has gone through the flow, we do the work and return a range of relevant bank account data depending on what fits your needs.',
      'bg-color': 'bg-pink',
      img: '/assets/img/carousel/use-cases-carousel-link-demo-2.png',
    },
    {
      header: 'Audit borrower assets',
      description:
        'With Assets, we produce the verified assets and other financial data you need in a consolidated report.',
      'bg-color': 'bg-purple',
      img: '/assets/img/carousel/use-cases-carousel-asset-report.jpg',
      'use-variant-image-layout': true,
      'variant-image-width': 464,
      'variant-image-height': 658,
    },
  ],
};

export const ctaData = {
  'marketo-key': 2007,
  title: 'Questions about how Plaid can fit into your business?',
  'with-subtext': true,
  subtext: 'Tell us how we can help and we’ll get in touch shortly.',
  'subtext-class': 'h4 regular',
  'include-phone': true,
};
